import firebase from 'firebase/app';
import 'firebase/remote-config';
import initializeFirebase from 'lib/firebaseInitializers/client';
import captureException from 'lib/captureException';

try {
  initializeFirebase();
} catch (e) {
  captureException(e);
}

export function getRemoteConfig(): firebase.remoteConfig.RemoteConfig {
  return firebase.remoteConfig();
}
